import { api } from '@/lib/api';
import { useAdmin } from '@/state/use-admin';
import axios from 'axios';
import { useEffect, useState } from 'react';

export const useUser = () => {
	const { user, setUser, clearUser } = useAdmin(state => ({
		user: state.user,
		setUser: state.setUser,
		clearUser: state.clearUser,
	}));

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		// 只在没有 user 时发起请求
		if (user) return;

		const fetchUser = async () => {
			setIsLoading(true);
			setError(null);

			try {
				const { data } = await api.get('/user');
				setUser(data);
			} catch (error) {
				if (
					axios.isAxiosError(error) &&
					error.response?.status === 401
				) {
					clearUser();
				}
				setError(error as Error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchUser();

		// 设置定时刷新 (每15分钟)
		const intervalId = setInterval(fetchUser, 1000 * 60 * 15);

		return () => clearInterval(intervalId);
	}, [user, setUser, clearUser]);

	return {
		data: user,
		isLoading,
		error,
	};
};
